import * as React from 'react';
import Icon from '../../widgets/Icons';
import ScaledCount from '../../widgets/ScaledCount';
import ScorePanel from '../../widgets/ScorePanel';
import LoadingIndicator from '../../widgets/LoadingIndicator';
import moment from 'moment';
import {
  INCIDENT_SCORE_DATE_FORMAT,
  MISSING_VALUE_PLACEHOLDER,
} from '../../constants';

type Props = {
  className?: string;
  ticketedInvestigations: number | null;
  isLoading: boolean;
};

export default class IncidentScore extends React.Component<Props> {
  render() {
    const { className, ticketedInvestigations: value, isLoading } = this.props;
    const thisWeek = moment().startOf('week');
    const firstWeek = thisWeek.clone().subtract(4, 'weeks');

    return (
      <ScorePanel
        className={className}
        icon={<Icon.Ticket />}
        title={'Ticketed Incidents'}
        score={
          isLoading ? (
            <div className="score-bar">
              <LoadingIndicator size="lg" />
            </div>
          ) : (
            <h1>
              {value && Number.isFinite(value) ? (
                <ScaledCount count={value} decimals={0} />
              ) : (
                MISSING_VALUE_PLACEHOLDER
              )}
            </h1>
          )
        }
      >
        Number of tickets brought to your attention between the weeks{' '}
        {firstWeek.format(INCIDENT_SCORE_DATE_FORMAT)} -{' '}
        {thisWeek.format(INCIDENT_SCORE_DATE_FORMAT)}
      </ScorePanel>
    );
  }
}
